import { useEffect, useState } from 'react'

import { CSRF_TOKEN_COOKIE_NAME } from '@/modules/trials/constants'
import * as Sentry from '@sentry/nextjs'
import Cookies from 'js-cookie'

export const useCsrf = (enabled: boolean) => {
	const [csrf, setCsrf] = useState('')

	useEffect(() => {
		if (!enabled) {
			return
		}

		fetch('/api/csrf/create/', { cache: 'no-store' })
			.then(() => {
				const token = Cookies.get(CSRF_TOKEN_COOKIE_NAME)

				if (token) {
					setCsrf(token)
				}
			})
			.catch((err) => {
				Sentry.captureException(
					new Error(`Error fetching CSRF cookie: ${err.message}`, { cause: err })
				)
				console.error(err)
			})
	}, [enabled])

	return csrf
}
